<div class="routing-section">

  <!-- Caricamento -->
  <div class="routing-state-box" *ngIf="isLoading">
    <div class="spinner-border text-primary" role="status"><span class="visually-hidden">Caricamento...</span></div>
    <p class="mt-3 text-muted mb-0">Caricamento dati di instradamento...</p>
  </div>

  <!-- Errore -->
  <div class="routing-state-box" *ngIf="!isLoading && errorMessage">
    <i class="fas fa-exclamation-circle fa-3x text-danger mb-3"></i>
    <p class="text-muted mb-3">{{ errorMessage }}</p>
    <button type="button" class="btn btn-primary btn-sm" (click)="load()">
      <i class="fas fa-redo-alt me-1"></i> Riprova
    </button>
  </div>

  <!-- Sezione vuota -->
  <div class="routing-state-box" *ngIf="!isLoading && !errorMessage && hasLoaded && comParcels.length === 0">
    <i class="fas fa-route fa-3x text-muted mb-3"></i>
    <p class="text-muted mb-0">Nessun dato di instradamento disponibile per questa pratica.</p>
    <small class="text-muted" *ngIf="parcel?.parcelCode">Nessuna tappa registrata per il collo <strong>{{ parcel?.parcelCode }}</strong>.</small>
  </div>

  <ng-container *ngIf="!isLoading && !errorMessage && comParcels.length > 0">

    <!-- Riepilogo -->
    <div class="routing-toolbar">
      <div class="routing-summary">
        <div class="routing-summary-item">
          <i class="fas fa-layer-group"></i>
          <span><strong>{{ comParcels.length }}</strong> {{ comParcels.length === 1 ? 'tappa' : 'tappe' }}</span>
        </div>
        <div class="routing-summary-item" *ngIf="dealer">
          <i class="fas fa-flag-checkered"></i>
          <span>Destinazione finale: <strong>{{ dealerName }}</strong></span>
        </div>
        <div class="routing-summary-item" *ngIf="parcel?.parcelDeliveryDate">
          <i class="fas fa-check-circle"></i>
          <span>Consegnato il <strong>{{ parcel?.parcelDeliveryDate | date:'dd/MM/yyyy HH:mm' }}</strong></span>
        </div>
      </div>
    </div>

    <!-- Danno non collocabile sul percorso: invito a indicare il magazzino con il bottone sotto il punto -->
    <ng-template #locationHintTpl>
      <span class="routing-chain-damage-note-hint" *ngIf="showLocationButtons">
        <i class="fas fa-map-marker-alt"></i>
        Se sai in quale magazzino del percorso è avvenuto il danno, indicalo con il bottone
        <i class="fas fa-map-marker-alt"></i> sotto il magazzino.
      </span>
    </ng-template>

    <!-- Eventi di danno che non ricadono su un punto del percorso -->
    <div class="routing-chain-damage-note" *ngIf="routingChainUnplacedDamages.length > 0">
      <i class="fas fa-exclamation-triangle"></i>
      <div>
        <strong>
          {{ getUnplacedDamageCount() === 1
             ? 'Evento di danno non collocabile sul percorso'
             : getUnplacedDamageCount() + ' eventi di danno non collocabili sul percorso' }}
        </strong>
        <span class="routing-chain-damage-note-item" *ngFor="let damage of routingChainUnplacedDamages">
          {{ damage.date ? (damage.date | date:'dd/MM/yyyy HH:mm') : 'Data non disponibile' }}
          <ng-container *ngIf="damage.endDate"> {{ getDamageRangeLabel(damage) }}</ng-container>
          <ng-container *ngIf="damage.count > 1"> ({{ damage.count }} eventi)</ng-container>
          <ng-container *ngIf="damage.place"> · {{ damage.place }} (fuori percorso)</ng-container>
          <ng-container *ngIf="!damage.place"> · magazzino non indicato</ng-container>
        </span>
        <ng-container *ngTemplateOutlet="locationHintTpl"></ng-container>
      </div>
    </div>

    <!-- Collo segnalato come danneggiato, ma senza evento di danno -->
    <div class="routing-chain-damage-note" *ngIf="isDamagedWithoutEvent()">
      <i class="fas fa-exclamation-triangle"></i>
      <div>
        <strong>Collo danneggiato: evento di danno non trovato</strong>
        <span class="routing-chain-damage-note-item">
          Il collo è segnalato come danneggiato, ma non risulta nessun evento di danno da collocare sul percorso.
        </span>
      </div>
    </div>

    <!-- Errore nella registrazione del magazzino del danno -->
    <div class="routing-chain-damage-note" *ngIf="locationError">
      <i class="fas fa-exclamation-circle"></i>
      <div>
        <strong>Magazzino del danno non registrato</strong>
        <span class="routing-chain-damage-note-item">{{ locationError }}</span>
      </div>
    </div>

    <!-- Percorso: O----T----O----T----O, punti di transito (O) collegati dalle tratte,
         ognuna con la sua azienda trasportatrice (T) -->
    <div class="routing-chain">
      <div class="routing-chain-track" [style.grid-template-columns]="routingChainGridColumns">

        <!-- Deviazioni (tappe MISROUTING) su corsie parallele al percorso -->
        <div class="chain-detour" *ngFor="let detour of routingChainDetours"
             [class.is-backward]="detour.backward"
             [style.grid-column]="detour.gridColumn"
             [style.grid-row]="routingChainDetourLanes - detour.lane"
             [style.--detour-lane]="detour.lane"
             [style.--detour-lane-height]="routingChainDetourLaneHeight + 'px'">
          <span class="chain-detour-link chain-detour-link--left" *ngIf="detour.leftAnchored"></span>
          <span class="chain-detour-link chain-detour-link--right" *ngIf="detour.rightAnchored"></span>
          <div class="chain-detour-track">
            <div class="chain-detour-point chain-detour-point--edge" *ngIf="!detour.startAnchored">
              <ng-container *ngTemplateOutlet="detourPointTpl; context: { name: detour.startName, place: detour.startPlace, damages: detour.startDamages, pickings: detour.startPickings }"></ng-container>
            </div>
            <ng-container *ngFor="let leg of detour.legs; let isLastLeg = last">
              <div class="chain-detour-leg">
                <span class="chain-detour-chip" [title]="leg.title">
                  <i class="fas" [ngClass]="detour.backward ? 'fa-arrow-left' : 'fa-shuffle'"></i>
                  <span class="chain-detour-chip-text">
                    Misrouting<ng-container *ngIf="leg.carrierName"> · {{ leg.carrierName }}</ng-container>
                  </span>
                </span>
                <span class="chain-detour-damage-link" *ngIf="leg.damages.length > 0" aria-hidden="true"></span>
              </div>
              <div class="chain-detour-point" *ngIf="!isLastLeg">
                <ng-container *ngTemplateOutlet="detourPointTpl; context: { name: leg.to, place: leg.toPlace, damages: leg.damages, pickings: leg.pickings }"></ng-container>
              </div>
            </ng-container>
            <div class="chain-detour-point chain-detour-point--edge" *ngIf="!detour.endAnchored">
              <ng-container *ngTemplateOutlet="detourPointTpl; context: { name: detour.endName, place: detour.endPlace, damages: detour.legs[detour.legs.length - 1].damages, pickings: detour.legs[detour.legs.length - 1].pickings }"></ng-container>
            </div>
          </div>
        </div>

        <!-- Punto di transito fuori percorso (sempre un magazzino) -->
        <ng-template #detourPointTpl let-name="name" let-place="place" let-damages="damages" let-pickings="pickings">
          <div class="step-marker-dot status-failed">
            <i class="fas fa-warehouse"></i>
            <span class="chain-point-damage-badge" *ngIf="damages?.length" aria-hidden="true">
              <i class="fas fa-exclamation"></i>
            </span>
            <span class="chain-point-picking-badges" *ngIf="pickings?.length">
              <span class="chain-point-picking-badge" *ngFor="let picking of pickings" [title]="getPickingTitle(picking)">
                <i class="fas fa-mobile-alt"></i>
                <span *ngIf="picking.date">{{ picking.date | date:'dd/MM/yyyy HH:mm' }}</span>
                <span *ngIf="picking.count > 1">×{{ picking.count }}</span>
              </span>
            </span>
          </div>
          <div class="chain-detour-point-label">
            <span class="chain-detour-point-role">Transito</span>
            <span class="chain-detour-point-name" [title]="name">{{ name }}</span>
            <span class="chain-detour-point-place" *ngIf="place">{{ place }}</span>
          </div>
          <div class="chain-detour-damages" *ngIf="damages?.length">
            <ng-container *ngFor="let damage of damages">
              <ng-container *ngTemplateOutlet="damageChipTpl; context: { damage: damage }"></ng-container>
            </ng-container>
          </div>
        </ng-template>

        <!-- Etichetta di un gruppo di eventi di danno -->
        <ng-template #damageChipTpl let-damage="damage">
          <span class="chain-point-damage" [title]="getDamageTitle(damage)">
            <span class="chain-point-damage-label">
              <i class="fas fa-exclamation-triangle"></i> Danno<ng-container *ngIf="damage.count > 1"> ×{{ damage.count }}</ng-container>
            </span>
            <span class="chain-point-damage-date" *ngIf="damage.date">{{ damage.date | date:'dd/MM/yyyy HH:mm' }}</span>
            <span class="chain-point-damage-date" *ngIf="damage.endDate">{{ getDamageRangeLabel(damage) }}</span>
          </span>
        </ng-template>

        <ng-container *ngFor="let node of routingChain; let i = index; let isFirst = first; let isLast = last">

          <!-- O: punto di transito -->
          <div class="chain-point" [class.is-final]="isLast"
               [style.grid-column]="2 * i + 1"
               [style.grid-row]="routingChainDetourLanes + 1">
            <div class="step-marker-dot"
                 [ngClass]="isLast && parcel?.parcelDeliveryDate ? 'status-completed' : getRoutingStatusClass(node.point.status)">
              <i class="fas" [ngClass]="node.point.kind === 'dealer' ? 'fa-store' : 'fa-warehouse'"></i>
              <span class="chain-point-damage-badge" *ngIf="node.damages.length > 0" aria-hidden="true">
                <i class="fas fa-exclamation"></i>
              </span>
              <span class="chain-point-picking-badges" *ngIf="node.pickings.length > 0">
                <span class="chain-point-picking-badge" *ngFor="let picking of node.pickings" [title]="getPickingTitle(picking)">
                  <i class="fas fa-mobile-alt"></i>
                  <span *ngIf="picking.date">{{ picking.date | date:'dd/MM/yyyy HH:mm' }}</span>
                  <span *ngIf="picking.count > 1">×{{ picking.count }}</span>
                </span>
              </span>
            </div>
            <span class="chain-point-role">
              {{ isLast ? (parcel?.parcelDeliveryDate ? 'Consegnato' : 'Destinazione') : (isFirst ? 'Partenza' : 'Transito') }}
            </span>
            <!-- Danno non collocabile e utente abilitato: bottone per registrare questo magazzino
                 sugli eventi di danno del collo (warehouseFrom); al termine il percorso viene ricaricato -->
            <ng-container *ngIf="showLocationButtons && node.point.kind === 'warehouse' && node.point.code">
              <button type="button" class="chain-point-location-btn"
                      [disabled]="!!assigningLocationCode"
                      [title]="'Danno avvenuto qui: registra ' + node.point.name + ' come magazzino in cui è avvenuto il danno (evento di danno del collo)'"
                      [attr.aria-label]="'Danno avvenuto qui: ' + node.point.name"
                      (click)="assignLocation(node)">
                <i class="fas" [ngClass]="assigningLocationCode === node.point.code ? 'fa-spinner fa-spin' : 'fa-map-marker-alt'"></i>
              </button>
            </ng-container>
            <span class="chain-point-name" [title]="node.point.name">{{ node.point.name }}</span>
            <span class="chain-point-place" *ngIf="node.point.place">{{ node.point.place }}</span>
          </div>

          <!-- Eventi di danno registrati in questo punto -->
          <div class="chain-damage-row" *ngIf="node.damages.length > 0"
               [class.is-first]="i === 0"
               [style.grid-column]="i === 0 ? 1 : (2 * i) + ' / ' + (2 * i + 2)"
               [style.grid-row]="routingChainDetourLanes + 2">
            <span class="chain-damage-link" *ngIf="i > 0" [class.is-linked]="!!routingChain[i - 1].leg" aria-hidden="true"></span>
            <div class="chain-damage-chips">
              <ng-container *ngFor="let damage of node.damages">
                <ng-container *ngTemplateOutlet="damageChipTpl; context: { damage: damage }"></ng-container>
              </ng-container>
            </div>
          </div>

          <!-- T: tratta verso il punto successivo, con l'azienda trasportatrice -->
          <div class="chain-leg" *ngIf="!isLast" [ngClass]="getRoutingStatusClass(node.leg?.status)"
               [style.grid-column]="2 * i + 2"
               [style.grid-row]="routingChainDetourLanes + 1">
            <div class="chain-leg-line"></div>
            <ng-container *ngIf="node.leg as leg">
              <div class="chain-leg-carrier"
                   [class.is-unassigned]="!leg.carrierCode"
                   [title]="leg.carrierCode ? leg.carrierName + ' (' + leg.carrierCode + ')' : 'Vettore non assegnato'">
                <i class="fas fa-truck"></i>
                <span class="chain-leg-carrier-name">{{ leg.carrierName || 'Non assegnato' }}</span>
              </div>
              <span class="chain-leg-seq" [title]="'Tappa ' + leg.sequence">Trasporto {{ leg.transport }}</span>
              <span class="mini-status" [ngClass]="getRoutingStatusClass(leg.status)">
                <i class="fas fa-circle"></i>
                {{ getRoutingStatusLabel(leg.status) }}
              </span>
            </ng-container>
          </div>

        </ng-container>
      </div>
    </div>

    <!-- Tabella degli orari, sotto il percorso -->
    <div class="routing-schedule">
      <div class="routing-schedule-title">
        <i class="fas fa-clock"></i>
        <span>Orari delle tappe</span>
      </div>
      <div class="routing-schedule-scroll">
        <table class="routing-schedule-table">
          <thead>
            <tr>
              <th>Tappa</th>
              <th>Da</th>
              <th>A</th>
              <th>Vettore</th>
              <th>Inizio</th>
              <th>Fine</th>
              <th>Stato</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of routingSchedule">
              <td>
                <span class="mini-seq" *ngIf="row.sequence">{{ row.sequence }}</span>
                <span class="schedule-misrouting-tag" *ngIf="row.misrouting">
                  <i class="fas fa-shuffle"></i> Misrouting
                </span>
              </td>
              <td>
                {{ row.from }}
                <ng-container *ngTemplateOutlet="scheduleDamagesTpl; context: { damages: row.damages }"></ng-container>
              </td>
              <td>{{ row.to }}</td>
              <td><ng-container *ngIf="row.carrierName; else noScheduleValue">{{ row.carrierName }}</ng-container></td>
              <td class="schedule-time"><ng-container *ngIf="row.start; else noScheduleValue">{{ row.start | date:'dd/MM/yyyy HH:mm' }}</ng-container></td>
              <td class="schedule-time"><ng-container *ngIf="row.end; else noScheduleValue">{{ row.end | date:'dd/MM/yyyy HH:mm' }}</ng-container></td>
              <td>
                <span class="mini-status" [ngClass]="getRoutingStatusClass(row.status)">
                  <i class="fas fa-circle"></i>
                  {{ getRoutingStatusLabel(row.status) }}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <ng-template #noScheduleValue><span class="schedule-empty">-</span></ng-template>
      <ng-template #scheduleDamagesTpl let-damages="damages">
        <span class="schedule-damage" *ngFor="let damage of damages" [title]="getDamageTitle(damage)">
          <i class="fas fa-exclamation-triangle"></i>
          Danno<ng-container *ngIf="damage.count > 1"> ×{{ damage.count }}</ng-container>
          <ng-container *ngIf="damage.date"> · {{ damage.date | date:'dd/MM/yyyy HH:mm' }}</ng-container>
          <ng-container *ngIf="damage.endDate"> {{ getDamageRangeLabel(damage) }}</ng-container>
        </span>
      </ng-template>
    </div>

  </ng-container>
</div>
